import { ActionIcon, Center, Group, Menu, SegmentedControl, Slider, Text, Tooltip, useMantineTheme, useMantineColorScheme } from '@mantine/core';
import {
    IconArrowsSort,
    IconCheck, IconLayoutSidebarLeftCollapse,
    IconLayoutSidebarLeftExpand, IconLayoutSidebarRightCollapse,
    IconLayoutSidebarRightExpand, IconMessage, IconRectangle,
    IconSquareToggle
} from '@tabler/icons-react';
import { CaptureToolbar } from 'core/components/index';
import { useEffect, useRef, useState } from 'react';
import { ApprovalLayoutTypes } from 'utils/constants';
import { logger } from 'utils/logger';
import TagTalent from '../../../core/components/capture/TagTalent';
import { CaptureEventType } from 'core/components/capture/CaptureThumb';
import { ApprovalEventTypes, CaptureSortFields } from './AssetViewer';
import classes from './Toolbar.module.scss';

const Toolbar = ({
    settings,
    settingsChange,
    selectedItems,
    onImageControlClick,
    selectedCompareFrame,
    onCaptureChange,
    showLayoutControls = true,
    showCaptureToolbar = true,
    showSettingControls = true,
    showFilterToggle = true,
    layoutOptions = [       
        {
            value: ApprovalLayoutTypes.SINGLE,
            label: <Center><IconRectangle size={16} /></Center>
        },
        {
            value: ApprovalLayoutTypes.COMPARE,
            label: <Center><IconSquareToggle size={16} /></Center>
        }]
}) => {
    const [starRating, setStarRating] = useState(-1);
    const theme = useMantineTheme();
    const { colorScheme } = useMantineColorScheme();
    const [thumbSize, setThumbsize] = useState(150);

    const controlToolsRef = useRef(null);
    const [showTagTalent, setShowTagTalent] = useState(false);

    const onLayoutChange = (val) => {
        const tmpSettings = { ...settings, layoutType: val };
        settingsChange(ApprovalEventTypes.SETTINGS_CHANGE, tmpSettings);
    };

    const onSliderChange = (val, settingObj) => {
        setThumbsize(val, () => {
            logger.log(settings, settingObj);
            if (val !== settings.thumbnailSize) {
                const tmpSettings = { ...settings, thumbnailSize: val };
                settingsChange(ApprovalEventTypes.SETTINGS_CHANGE, tmpSettings);
            }
        });
    };

    // update the settings when the thumbnail size has changed
    useEffect(() => {
        const tmpSettings = { ...settings, thumbnailSize: thumbSize };
        settingsChange(ApprovalEventTypes.SETTINGS_CHANGE, tmpSettings);
    }, [thumbSize]);

    const onPanelToggleClick = () => {
        const tmpSettings = { ...settings, infoOpen: !settings.infoOpen };
        settingsChange(ApprovalEventTypes.SETTINGS_CHANGE, tmpSettings);
    };

    const onFilterPanelToggleClick = () => {
        const tmpSettings = { ...settings, filterOpen: !settings.filterOpen };
        settingsChange(ApprovalEventTypes.SETTINGS_CHANGE, tmpSettings);
    };

    // useEffect(() => {
    //   logger.log('TOOLBAR REF CHANGE')
    //   if(controlToolsRef.current){
    //     // get the children.
    //     let ref = controlToolsRef.current;
    //     let controls = ref.getElementsByClassName('openseacontrols');

    //     logger.log(controlToolsRef.current.children, controls)
    //     if(controls && controls.length){
    //       if(selectedCompareFrame === 0){
    //         controls[1] && controls[1].classList.add("hidden");
    //         controls[0].classList.remove("hidden");
    //       }if(selectedCompareFrame === 1){
    //         controls[1] && controls[1].classList.remove("hidden");
    //         controls[0].classList.add("hidden");
    //       }
    //     }
    //   }

    // },[selectedCompareFrame,settings.layoutType,controlToolsRef.current])

    const ratingsCls = selectedItems && selectedItems.length > 1 ? '' : classes.hiddenContainer;

    useEffect(() => {
        /**
         * Method to calculate the common rating across all selected items. If they are the same we set them otherwise
         * we set to empty state
         */
        const calculateRating = () => {
            var isSame = true;
            var rating = selectedItems && selectedItems.length ? parseInt(selectedItems[0].star) : -1;

            if (rating > -1) {
                for (let i = 0; i < selectedItems.length; i++) {
                    const val = selectedItems[i];
                    if (parseInt(val.star) !== rating) {
                        isSame = false;
                        break;
                    }
                }
            }
            logger.log(rating);
            return isSame ? rating : -1;
        };
        setStarRating(calculateRating());
    }, [selectedItems]);

    const onSortChange = (type, val) => {
        logger.log(type);
        const tmpSettings = { ...settings, [type]: val };
        settingsChange(ApprovalEventTypes.SETTINGS_CHANGE, tmpSettings);
    };
    const spans = settings.layoutType === ApprovalLayoutTypes.GRID ? [5, 2, 5] : [3, 6, 3];

    return (
        <Group
            style={{ width: '100%' }}
            justify='space-between'
            align='center'
            cols={3}
            className={`approvaltoolbar ${classes.container} unhightable`}
            data-layouttype={`${settings.layoutType}`}
            data-selectedframe={`${selectedCompareFrame}`}
            pr='md'>
            <Group span={spans[2]} style={{ display: 'flex',  width: 180 }}>
                {showLayoutControls ? (
                    <Group>
                        {showFilterToggle ? (
                            <Tooltip position='bottom-start' label={settings.filterOpen ? 'Hide Filter Panel' : 'Show Filter Panel'}>
                            <ActionIcon variant='default' onClick={() => onFilterPanelToggleClick()}>
                                {settings.filterOpen ? <IconLayoutSidebarLeftCollapse size={18} /> : <IconLayoutSidebarLeftExpand size={18} />}
                            </ActionIcon>
                        </Tooltip>
                        ) : null}
                        <SegmentedControl
                            value={settings.layoutType}
                            onChange={onLayoutChange}
                            data={layoutOptions.map((val) => ({
                                value: val.value,
                                label: <Center>{val.label}</Center>,
                            }))}
                                
                        />
                    </Group>
                ) : null}
            </Group>

            <Group span={spans[1]}>
                <Group ref={controlToolsRef} id='controllerCol' style={{ justifyContent: 'center' }}>
                    {showCaptureToolbar ? (
                        <div className={ratingsCls} style={{position:'relative'}}>
                            <TagTalent opened={showTagTalent} onChange={setShowTagTalent} captures={selectedItems}>
                                <div>
                                <CaptureToolbar size='md'
                                    selectedItems={selectedItems}
                                    onCaptureChange={(type, data, items) => {
                                        onCaptureChange(type, data, items);
                                        if (type === CaptureEventType.TAG_TALENT) {
                                            setShowTagTalent(true);
                                        }
                                    }}
                                    rating={starRating}
                                   
                                />
                                </div>
                            </TagTalent>
                        </div>
                    ) : null}

                    {/* <ImageControlToolbar onControlsClick={onImageControlClick} /> */}
                </Group>
            </Group>

            <Group span={spans[2]} style={{ display: 'flex', justifyContent: 'end', width: 150 }}>
                {showSettingControls ? (
                    <Group style={{ display: 'flex', justifyContent: 'end' }}>
                        {settings.layoutType === ApprovalLayoutTypes.GRID ? (
                            <Group>
                                <Text size={'sm'} className='unhightable'>
                                    Size
                                </Text>
                                <Slider min={150} max={300} style={{ width: 120 }} value={thumbSize} onChange={setThumbsize} />
                            </Group>
                        ) : null}
                        {/* <Select
                    sx={{width:150}}
                    placeholder="Sort By"
                    data={[
                      { value: 'sku', label: 'Capture Date' },
                      { value: 'desc', label: 'Modified Date' },
                      { value: 'location', label: 'Star Rating' },
                      { value: 'status', label: 'Session Name' },
                    ]}
                  /> */}
                        {/* <SortMenu theme={theme} settings={settings} onSortChange={onSortChange} /> */}
                        <Tooltip position='bottom' label={settings.infoOpen ? 'Hide Info Panel' : 'Show Info Panel'}>
                            <ActionIcon variant='default' onClick={() => onPanelToggleClick()}>
                                {settings.infoOpen ? <IconLayoutSidebarRightCollapse size={18} /> : <IconLayoutSidebarRightExpand size={18} />}
                            </ActionIcon>
                        </Tooltip>
                    </Group>
                ) : null}
            </Group>
        </Group>
    );
};

export default Toolbar;

const SortMenu = (props) => {
    return (
        <Menu shadow='md' width={200}>
            <Menu.Target>
                <Tooltip position='bottom' label='Sort Items'>
                    <ActionIcon>
                        <IconArrowsSort size={18} />
                    </ActionIcon>
                </Tooltip>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Label>Sort By</Menu.Label>
                {CaptureSortFields.map((val, idx) => {
                    return (
                        <Menu.Item key={idx} onClick={(e) => props.onSortChange('sortBy', val)}>
                            <Group spacing={'xs'}>
                                <div style={{ width: 20 }}>{val.value === props.settings.sortBy.value ? <IconCheck size={14} color={props.theme.colors.brand[4]} /> : null}</div>
                                <Text>{val.label}</Text>
                            </Group>
                        </Menu.Item>
                    );
                })}
                <Menu.Label>Order</Menu.Label>
                <Menu.Item onClick={(e) => props.onSortChange('sortDirection', 'asc')}>
                    <Group spacing={'xs'}>
                        <div style={{ width: 20 }}>{'asc' === props.settings.sortDirection ? <IconCheck size={14} color={props.theme.colors.brand[4]} /> : null}</div>
                        <Text>Ascending</Text>
                    </Group>
                </Menu.Item>
                <Menu.Item onClick={(e) => props.onSortChange('sortDirection', 'desc')}>
                    <Group spacing={'xs'}>
                        <div style={{ width: 20 }}>{'desc' === props.settings.sortDirection ? <IconCheck size={14} color={props.theme.colors.brand[4]} /> : null}</div>
                        <Text>Descending</Text>
                    </Group>
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};
